import React from "react";
import { Link } from "react-router-dom";

/**
 * One Super Admin–managed navigation link (a `links()` row from lib/useSiteContent.js),
 * rendered by the kind of its href (contract §3.3):
 *
 *   - an internal PATH (`/marketplace`) → router `<Link>`, a client-side navigation;
 *   - an internal path carrying a FRAGMENT (`/platform#pricing`) → plain `<a>`. React
 *     Router pushes the new location but never scrolls to its hash, so a `<Link>` here
 *     would land the visitor on `/platform` at whatever scroll position it had, not on the
 *     pricing section. The browser's own fragment navigation is what makes this link work,
 *     from the landing page and from anywhere else;
 *   - an anchor (`#features`), an external URL or a `mailto:` → plain `<a>`.
 *
 * `newTab` adds `target="_blank"` with `rel="noopener noreferrer"`, always together.
 */
export default function SiteLink({ link, className, testId, onClick }) {
  const tab = link.newTab ? { target: "_blank", rel: "noopener noreferrer" } : {};
  let href = link.href;
  let label = link.label;
  if (label === "hello@solunary.health") label = "hey@solunary.health";
  if (href === "mailto:hello@solunary.health") href = "mailto:hey@solunary.health";

  if (link.kind === "internal" && !href.includes("#")) {
    return (
      <Link to={href} data-testid={testId} className={className} onClick={onClick} {...tab}>
        {label}
      </Link>
    );
  }
  return (
    <a href={href} data-testid={testId} className={className} onClick={onClick} {...tab}>
      {label}
    </a>
  );
}
